/* GT Phase 7 (10 Oct 2026): occasions slider. Native scroll-snap does the sliding; prev / next step one card
   and switch off at each end, and the buttons hide when everything fits. No libraries. Reduced motion: instant steps. */
(()=>{
  const R=matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll("[data-gx-occ]").forEach(w=>{
    const t=w.querySelector("[data-gx-occ-track]"),p=w.querySelector("[data-gx-occ-prev]"),n=w.querySelector("[data-gx-occ-next]");
    if(!t||!p||!n)return;
    const step=()=>{const a=t.children[0],b=t.children[1];return a&&b?b.offsetLeft-a.offsetLeft:t.clientWidth*.8},
      sync=()=>{const m=t.scrollWidth-t.clientWidth-2;p.setAttribute("aria-disabled",t.scrollLeft<=2);n.setAttribute("aria-disabled",t.scrollLeft>=m);w.classList.toggle("is-static",m<=0)},
      go=d=>e=>{if(e.currentTarget.getAttribute("aria-disabled")==="true")return;t.scrollBy({left:d*step(),behavior:R?"auto":"smooth"})};
    p.addEventListener("click",go(-1));n.addEventListener("click",go(1));
    let f=0;t.addEventListener("scroll",()=>{if(!f)f=requestAnimationFrame(()=>{f=0;sync()})},{passive:!0});
    addEventListener("resize",sync);sync()
  })
})();
